/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react'

import { useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import Alert from "@material-ui/lab/Alert";
import { Grid } from "@material-ui/core";

import { useQuery } from '@apollo/client';
import {GET_PAGE, UPDATE_PAYMENT} from "../queries";
import { useThemeData } from '../context/ThemeDataContext'
import { useDownloadData } from '../context/DownloadData';
import GeneralButton from "../components/Buttons";
import GeneralText from "../components/Fonts";
import SharePhotosComponent from '../components/Photo/SharePhotosComponent';
import ReactHtmlParser from "react-html-parser";

function SuccesPage(props) {
    const {DownloadData} = useDownloadData();
    const {font_family} = useThemeData().themeData.site.theme;
    const site_id = useThemeData().themeData.site.site_id;
    const {photographerType} = useThemeData();
    const { share_photos_facebook } = useThemeData().modules;
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const trxid = urlParams.get('trxid');
    const order_id = urlParams.get('order_id');
    var doctitle = window.location.href;
    var parts = doctitle.split('/');
    document.title = parts[2];
    const session_id = localStorage.getItem('session_id');

    const { loading: loadingPage, error: errorPage, data: dataPage } =
        useQuery(GET_PAGE, {
            variables: {
                site_id: site_id,
                url: 'succes'
            },
            fetchPolicy: 'cache-and-network'
        })


    const { loading: loadingPaymentUpdate, error: errorPaymentUpdate, data: dataPaymentUpdate } =
        useQuery(UPDATE_PAYMENT, {
            variables: {
              session_id: session_id,
              site_id: site_id,
              trxid: trxid,
              order_id: order_id,
              type: props.match.params.type,
              payment_step: '', // wat moet hier komem?
              returnUrl: window.location.protocol + "//" + window.location.host
            },
            onCompleted: (data) => {
                if (localStorage.hasOwnProperty('cart_session_id')) {
                    localStorage.removeItem('cart_session_id');
                    localStorage.removeItem('order_id');
                }
                //refetchCart();
            },
        });

    if (loadingPaymentUpdate) return <p>{props.t('Loading...')}</p>;
    if (errorPaymentUpdate) return <p>{props.t('Looks like we have a problem...')}</p>;
    if (!dataPaymentUpdate) return null;
    if (dataPaymentUpdate.updatePayment.status === 'error'){
        // window.location.href = dataPaymentUpdate.updatePayment.checkoutUrl;
    }

    if (loadingPage) return <p>{props.t('Loading...')}</p>
    if (errorPage) return <p>{props.t('Looks like we have a problem...')}</p>
    if (!dataPage) return null

    const html = dataPage.page.tekst



    return (
        <Grid container direction="row" className="margin-around success-page" style={{fontFamily: `${font_family}`}}>
            <Grid item lg={12} md={12} sm={12} className="mb-2" >

                <Alert severity="info">
                    <GeneralText
                        variant="h3"
                        gutterBottom={true}
                        >
                        {/*{props.t('checkout:Thank you for the order!')}*/}
                    </GeneralText>
                    {ReactHtmlParser(html)}
                    {/*<p >{props.t('checkout:Mail')}</p>*/}
                    {/*<p className="no-margin-bttm">{props.t('checkout:Contact')}</p>*/}
                    {/*<p >{props.t('checkout:No Mail')}</p>*/}
                    {/*<p>{props.t('checkout:Confirmation message')}</p>*/}
                    {/*<p>{props.t('checkout:Downloads')}</p>*/}

                </Alert>
                <Grid container direction="row" spacing={1}>

                        {/*<GeneralButton*/}
                        {/*    href='/contact'*/}
                        {/*    className="btn btn-light align-button m-2">*/}
                        {/*    {props.t('Contact')}*/}
                        {/*</GeneralButton>*/}
                        {DownloadData && DownloadData.length > 0 &&
                        <GeneralButton
                            href='/my-downloads'
                            className="btn btn-light align-button m-2">
                            {props.t('checkout:Download')}
                        </GeneralButton>
                        }
                    {photographerType === "equestrianphotoservice" &&
                        <GeneralButton
                            href='https://paardensportfoto.nl/evenementen/'
                            className="btn btn-light align-button m-2">
                            {props.t('checkout:Home')}
                        </GeneralButton>
                    }
                </Grid>
            </Grid>
            {share_photos_facebook === "true" &&
            <SharePhotosComponent />
            }
        </Grid >
    );

}

export default React.memo(withTranslation(['message', 'checkout'])(SuccesPage));
